import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c0790c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load-style" }
const _hoisted_2 = {
  key: 0,
  class: "sk-plane"
}
const _hoisted_3 = {
  key: 1,
  class: "sk-chase"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-chase-dot\" data-v-4c0790c4></div><div class=\"sk-chase-dot\" data-v-4c0790c4></div><div class=\"sk-chase-dot\" data-v-4c0790c4></div><div class=\"sk-chase-dot\" data-v-4c0790c4></div><div class=\"sk-chase-dot\" data-v-4c0790c4></div><div class=\"sk-chase-dot\" data-v-4c0790c4></div>", 6)
const _hoisted_10 = [
  _hoisted_4
]
const _hoisted_11 = {
  key: 2,
  class: "sk-bounce"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-bounce-dot" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-bounce-dot" }, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "sk-wave"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-wave-rect\" data-v-4c0790c4></div><div class=\"sk-wave-rect\" data-v-4c0790c4></div><div class=\"sk-wave-rect\" data-v-4c0790c4></div><div class=\"sk-wave-rect\" data-v-4c0790c4></div><div class=\"sk-wave-rect\" data-v-4c0790c4></div>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = {
  key: 4,
  class: "sk-pulse"
}
const _hoisted_23 = {
  key: 5,
  class: "sk-flow"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-flow-dot" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-flow-dot" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-flow-dot" }, null, -1))
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 6,
  class: "sk-swing"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-swing-dot" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-swing-dot" }, null, -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 7,
  class: "sk-circle"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div><div class=\"sk-circle-dot\" data-v-4c0790c4></div>", 12)
const _hoisted_45 = [
  _hoisted_33
]
const _hoisted_46 = {
  key: 8,
  class: "sk-circle-fade"
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div><div class=\"sk-circle-fade-dot\" data-v-4c0790c4></div>", 12)
const _hoisted_59 = [
  _hoisted_47
]
const _hoisted_60 = {
  key: 9,
  class: "sk-grid"
}
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div><div class=\"sk-grid-cube\" data-v-4c0790c4></div>", 9)
const _hoisted_70 = [
  _hoisted_61
]
const _hoisted_71 = {
  key: 10,
  class: "sk-fold"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-fold-cube" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-fold-cube" }, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-fold-cube" }, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-fold-cube" }, null, -1))
const _hoisted_76 = [
  _hoisted_72,
  _hoisted_73,
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = {
  key: 11,
  class: "sk-wander"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-wander-cube" }, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-wander-cube" }, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sk-wander-cube" }, null, -1))
const _hoisted_81 = [
  _hoisted_78,
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = {
  key: 12,
  class: "sk-win10"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_84 = [
  _hoisted_83
]

import { ref, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'loading',
  props: {
  type: Number,
},
  setup(__props) {

const style = ref(null)
const props = __props

onMounted(() => {
  style.value = props.type || 1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (style.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (style.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_10))
      : _createCommentVNode("", true),
    (style.value == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
      : _createCommentVNode("", true),
    (style.value == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_21))
      : _createCommentVNode("", true),
    (style.value == 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22))
      : _createCommentVNode("", true),
    (style.value == 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_27))
      : _createCommentVNode("", true),
    (style.value == 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
      : _createCommentVNode("", true),
    (style.value == 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_45))
      : _createCommentVNode("", true),
    (style.value == 9)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_59))
      : _createCommentVNode("", true),
    (style.value == 10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_70))
      : _createCommentVNode("", true),
    (style.value == 11)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_76))
      : _createCommentVNode("", true),
    (style.value == 12)
      ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_81))
      : _createCommentVNode("", true),
    (style.value == 13)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
      : _createCommentVNode("", true)
  ]))
}
}

})